export const timezoneOptions = [
  { key: '0', value: 'America/Adak', text: 'Adak' },
  { key: '1', value: 'America/Anchorage', text: 'Anchorage' },
  { key: '2', value: 'America/Boise', text: 'Boise' },
  { key: '3', value: 'America/Chicago', text: 'Chicago' },
  { key: '4', value: 'America/Denver', text: 'Denver' },
  { key: '5', value: 'America/Detroit', text: 'Detroit' },
  {
    key: '6',
    value: 'America/Indiana/Indianapolis',
    text: 'Indiana - Indianapolis',
  },
  { key: '7', value: 'America/Indiana/Knox', text: 'Indiana - Knox' },
  { key: '8', value: 'America/Indiana/Marengo', text: 'Indiana - Marengo' },
  {
    key: '9',
    value: 'America/Indiana/Petersburg',
    text: 'Indiana - Petersburg',
  },
  {
    key: '10',
    value: 'America/Indiana/Tell_City',
    text: 'Indiana - Tell City',
  },
  { key: '11', value: 'America/Indiana/Vevay', text: 'Indiana - Vevay' },
  {
    key: '12',
    value: 'America/Indiana/Vincennes',
    text: 'Indiana - Vincennes',
  },
  { key: '13', value: 'America/Indiana/Winamac', text: 'Indiana - Winamac' },
  { key: '14', value: 'America/Juneau', text: 'Juneau' },
  {
    key: '15',
    value: 'America/Kentucky/Louisville',
    text: 'Kentucky - Louisville',
  },
  {
    key: '16',
    value: 'America/Kentucky/Monticello',
    text: 'Kentucky - Monticello',
  },
  { key: '17', value: 'America/Los_Angeles', text: 'Los Angeles' },
  { key: '18', value: 'America/Menominee', text: 'Menominee' },
  { key: '19', value: 'America/Metlakatla', text: 'Metlakatla' },
  { key: '20', value: 'America/New_York', text: 'New York' },
  { key: '21', value: 'America/Nome', text: 'Nome' },
  {
    key: '22',
    value: 'America/North_Dakota/Beulah',
    text: 'North Dakota - Beulah',
  },
  {
    key: '23',
    value: 'America/North_Dakota/Center',
    text: 'North Dakota - Center',
  },
  {
    key: '24',
    value: 'America/North_Dakota/New_Salem',
    text: 'North Dakota - New Salem',
  },
  { key: '25', value: 'America/Phoenix', text: 'Phoenix' },
  { key: '26', value: 'America/Sitka', text: 'Sitka' },
  { key: '27', value: 'America/Yakutat', text: 'Yakutat' },
  { key: '28', value: 'Pacific/Honolulu', text: 'Honolulu' },
];
export const timezones = [
  { key: '1', value: 'America/Chicago', text: 'Chicago' },
  { key: '2', value: 'America/Denver', text: 'Denver' },
  { key: '3', value: 'America/Los_Angeles', text: 'Los Angeles' },
  { key: '4', value: 'America/New_York', text: 'New York' },
  { key: '5', value: 'America/Phoenix', text: 'Phoenix' },
];
